/**
 * Created by zhaoy on 2021/1/15
 * Desc: 学校交费服务
 */

import {connect} from "react-redux";
import React, {Component} from 'react'
import {Button, message, Avatar} from "antd";
import {Toast} from "antd-mobile";
import {changeTabIndex} from "../../redux/actions/action";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import { isObjEmpty } from '../../utils/common'
import './SchoolFees.css'

class SchoolFees extends Component {

    constructor (props) {
        super(props)
        this.state = {
            name:'SchoolFees',
            way: 0,
            schoolFeesList: [],
        }
    }

    componentDidMount() {
        document.title = '学校收费'
        Toast.loading('', 0)
        this.getSchoolFees()
    }

    render () {
        const { stu, stuPhoto, stuName, userInfo } = this.props
        const { schoolFeesList } = this.state

        const rechargeItems = []
        schoolFeesList.forEach((rechargeObj, index) => {
          rechargeItems.push(<div className='service-content-layout'>
            <div
              className='service-content-item'
              onClick={rechargeObj.ct_payStatus != null && rechargeObj.ct_payStatus == 'PAYED'? '' : this.onRechargeClick.bind(this, index,
                rechargeObj.cid)}>
                <span
                  className='service-content-item-text'>{rechargeObj.c_title}</span>
              <span
                className='service-content-item-text'>¥ {rechargeObj.c_money}</span>
              <div style={{ flex: 1 }}>{rechargeObj.ct_payStatus !== null && rechargeObj.ct_payStatus === 'PAYED'?'已缴费':<span className="color_red">未缴费</span>}</div>
            </div>
            {/*服务说明*/}
            <span className='service-content-title'>服务说明</span>
            <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: rechargeObj.c_details }} /></span>
          </div>)
        })

        return (
        <div id='info-service-root'>
            {/*头部-个人信息*/}
            <div className='info-service-head bg_light_green'>
              {isObjEmpty(stuPhoto)
                ? <Avatar size={64} icon='user'/>
                :
                <Avatar size={64} src={stuPhoto}/>}
                <div className="text_white span_16 margin_top_5">{stuName}</div>
            </div>

            <div id='info-service-body'>
              {/*服务内容*/}
              <span className='service-content-title'>服务内容</span>
              <span id='body-service-content'><div dangerouslySetInnerHTML={{ __html: userInfo.parent.chargeContent }} /></span>

              {/*信息费列表*/}
              <span className='service-content-title'>信息费（元/年）</span>
              <div style={{ marginTop: '6px' }}>{rechargeItems}</div>
            </div>
            <div
                style={{
                  textAlign: 'center',
                  margin: '2px 10px 20px 0px',
                }}>
                <span style={{
                  color: 'blue',
                  fontSize: '16px',
                  borderBottom: '1px solid blue',
                  fontWeight: '600',
                }}
                      onClick={this.toChargeRecord}>历史交费记录</span>
            </div>
        </div>
      )
    }

    getSchoolFees = () => {

        let {schoolFeesList} = this.state
        schoolFeesList.length = 0

        fetchGet(API.SCHOOL_CHARGE_LIST, {
            schoolId: this.props.userInfo.user.schoolId,
            stuId: this.props.userInfo.parent.student.stuId,
        }).then(response => {
            Toast.hide();

            if (response && response.data && response.data.rulesList &&
                response.data.rulesList.length > 0) {
                schoolFeesList = response.data.rulesList
            }
            this.setState({
                schoolFeesList,
            }, () => {
                console.log(schoolFeesList)
            })

        }).catch(error => {
            Toast.hide();
            this.setState({
                schoolFeesList,
            })
            if (typeof error === 'string') {
                message.error(error)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    onRechargeClick = (index, rid) => {
        this.wxPayRequest(rid)
    }

    wxPayRequest = (rid) => {
        let err = ''
        Toast.loading('')
        let openId = ''
        if (typeof this.props.userOpenid == 'undefined' ||
          this.props.userOpenid == null || this.props.userOpenid == '') {
          Toast.fail('openId为空，请退出重新进入应用')
          return
        } else {
          openId = this.props.userOpenid
        }

        fetchPost(API.INFO_SERVICE_CHARGE_ORDER, {
          openId: openId,
          rId: rid,
          studentId: this.props.userInfo.parent.student.stuId, //this.props.userInfo.parent.student.stuId
          parentId: this.props.userInfo.parent.parentId,   //this.props.userInfo.parent.parentId
          appId: this.props.userInfo.appId,
        }).then((response) => {
          Toast.hide()
          const data = response.data
          err = data
          if(err === undefined ){
            err=response.message;
          }
          if (typeof WeixinJSBridge == 'undefined') {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady',
                this.onBridgeReady(data), false)
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady',
                this.onBridgeReady(data))
              document.attachEvent('onWeixinJSBridgeReady',
                this.onBridgeReady(data))
            }
          } else {
            this.onBridgeReady(data)
          }
        }).catch((error) => {
          console.log('error:' + JSON.stringify(error))
          Toast.show('支付失败！' + err)
        })
    }

    onBridgeReady = (json) => {
       console.log('json:', json)
       const that = this
       window.WeixinJSBridge.invoke(
         'getBrandWCPayRequest', JSON.parse(json),
         function (res) {
           if (res.err_msg == 'get_brand_wcpay_request:ok') {
             // 使用以上方式判断前端返回,微信团队郑重提示：
             //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
             Toast.success('支付成功！')
             // that.props.history.push('/payResult/' + that.state.amount)
           } else {
            Toast.fail('支付失败！')
            // message.info("支付失败:" + res.err_msg)
            // that.setState({
            //     payInfo: json,
            //     payResult: "支付失败:" + JSON.stringify(res)
            // });
          }
       })
    }

    toChargeRecord = () => {
      this.props.history.push('/payForSchool')
    }

}

const mapStateToProps = state => ({
    tabIndex: state.appState.tabIndex,
    userInfo: { ...state.redUserInfo },
    stu: state.redUserInfo.parent.student,
    userOpenid: state.redUserInfo.userOpenid,
    stuPhoto: state.redUserInfo.parent.student
      ? state.redUserInfo.parent.student.stuPhoto
      : '',
    stuName: state.redUserInfo.parent.student
      ? state.redUserInfo.parent.student.stuName
      : '',
})

const mapDispatchToProps = dispatch => ({
    changeTabIndex: (tabIndex) => {
        dispatch(changeTabIndex(tabIndex))
    },
})

export default connect(mapStateToProps, mapDispatchToProps,)(SchoolFees)